<template>
<div class="main-content" ref="targetDiv">
  <div class="left-content">
    <div class="service-title">服务遍布全国</div>
    <div class="tip">通过网络及线下渠道为全国学生提供专业服务</div>
    <div class="num-content">
      <div class="province-num">
        <!--<digit-roll
            :rollDigits='targetNumber'
            :flipStra = "true"
            @roll-finish="restart"
        />-->
        <i class="province" ref="serviceNumRef">
          <count-to v-show="showCountService" :decimals="2" ref="serviceCountTo" :startVal='12.34' :endVal='targetNumber' :duration=3000></count-to>
        </i>
        <!--<div class="number">{{ animatedNumber }}</div>-->
        万人次
      </div>
      <div class="province-num leftProvince" ref="provinceNumRef">
        <i class="province">
          <count-to v-show="showCountService" ref="provinceCountTo" :startVal='12' :endVal='provinceNum' :duration=1000></count-to>
        </i>省级行政区
      </div>
    </div>
  </div>
  <div class="right-content">
    <china-map></china-map>
    <!--<div class="mapContainer" ref="echartsContainer"></div>-->
  </div>
</div>
</template>

<script>
import CountTo from 'vue-count-to';
/*import DigitRoll from '@huoyu/vue-digitroll';*/
import 'animate.css'; // 导入animate.css样式文件
import ChinaMap from "@/components/ChinaMap"
export default {
  name: "ServiceContent",
  data() {
    return {
      targetNumber: 128.6, // 人数
      duration:800, //动画持续时间，单位为毫秒
      provinceNum:34, //省级行政区
      interval: 20,
      currentNumber: 0,
      showCountService:false,
      option:null,
      geoJson:null,
    }
  },
  components: {
    CountTo,
    /*DigitRoll,*/
    ChinaMap
  },
  mounted() {

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // 当目标元素50%可见时触发回调
    };

    const observer = new IntersectionObserver(this.handleIntersection, options);
    observer.observe(this.$refs.targetDiv);
  },

  created() {

  },
  computed:{
  },
  methods:{
    // 使用 count-to 实现数字加载动画
    animateCounter() {
      const serviceCountTo = this.$refs.serviceCountTo;
      const provinceCountTo = this.$refs.provinceCountTo;
      if (serviceCountTo) {
        serviceCountTo.start();
        provinceCountTo.start();
      }
    },
    handleIntersection(entries) {
      entries.forEach(entry => {
        const serviceCountTo = this.$refs.serviceCountTo;
        const provinceCountTo = this.$refs.provinceCountTo;
        if (entry.isIntersecting) {
          this.showCountService = true;
          if (serviceCountTo) {
            serviceCountTo.start();
            provinceCountTo.start();
          }
        }
      });
    },

  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'numberFamily';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509867414.ttf');
}
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.main-content{
  width: 1200px;
  height: 100%;
  position: relative;
  margin: 0 auto;
  padding-top: 200px;
  .left-content{
    width: 42%;
    position: absolute;
    /*top: 258px;*/
    /*top: 210px;
    left: 360px;*/
    z-index: 10000;
  }
  .service-title{
    width: 320px;
    font-size: 40px;
    font-family: 'SourceHanSansCNBold Microsoft YaHei';
    font-weight: bold;
    color: #0A0D0F;
    line-height: 60px;
  }
  .tip{
    width: 400px;
    height: 16px;
    font-size: 20px;
    font-family: 'SourceHanSansCN Microsoft YaHei';
    font-weight: 400;
    color: #909295;
    line-height: 24px;
    margin-top: 36px;
  }
  .num-content{
    margin-top: 100px;
    display: flex;
    i{
      font-style: normal;
      font-size: 60px;
      font-family: 'numberFamily';
      color: #0086FF;
      line-height: 68px;
      font-weight: bold;
    }
    .province-num{
      font-size: 16px;
      font-family: 'numberFamily';
      font-weight: 400;
      color: #434649;
      line-height: 155px;
      i{
        font-weight: bold;
      }
    }
    .leftProvince{
      margin-left: 48px;
    }
    .person-num{
      font-size: 16px;
      font-family: 'numberFamily';
      font-weight: 400;
      color: #434649;
      display: flex;
      line-height: 155px;
      justify-content: flex-start;
      /*div{
        flex: 1;
      }
      .title{
        align-items: flex-end;
        line-height: 155px;
      }
      .d-roll-wrapper{
        color: #0086FF;
        margin-right: 8px;
        font-size: 48px;
        font-family: 'numberFamily';
        line-height: 68px;
        height: 68px;
      }
      .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
      }
      .fade-enter, .fade-leave-to {
        opacity: 0;
      }*/
      .number {
        animation-duration: 3s; /* 设定动画持续时间 */
        color: #0086FF;
        font-size: 60px;
        font-family: 'numberFamily';
      }
    }
  }
  .right-content{
    width: 850px;
    position: absolute;
    left: 37%;
    /*top: 120px;*/
    top: 0;
    z-index: 100;
    .mapContainer{
      width: 100%;
      height: 760px;
    }
  }
}
</style>